import React from 'react';

const CallbackSettings = ({ formData, handleChange, errors }) => {
  return (
    <div className="bg-white rounded-lg shadow p-6 mb-6">
      <h2 className="text-xl font-semibold text-gray-800 border-b border-gray-200 pb-3 mb-6">
        Callback Settings
      </h2>
      
      {/* Callback URL Talent Assessment */}
      <div className="mb-6">
        <label 
          htmlFor="callback_talent_assessment" 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          (Callback URL) Talent Assessment 
        </label>
        <input
          type="text"
          id="callback_talent_assessment"
          name="callback_talent_assessment"
          value={formData.callback_talent_assessment}
          onChange={handleChange}
          className={`w-full p-2 border rounded-md ${errors.callback_talent_assessment ? 'border-red-500' : 'border-gray-300'}`}
          placeholder="https://example.com/callback"
        />
        <p className="mt-1 text-sm text-gray-500">
          URL that will be called when a talent assessment is completed (including talent profile and role category).
        </p>
        {errors.callback_talent_assessment && (
          <p className="mt-1 text-sm text-red-600">{errors.callback_talent_assessment}</p>
        )}
      </div>
    
      {/* Callback URL Talent Report */}
      <div className="mb-6">
        <label 
          htmlFor="callback_talent_report" 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          (Callback URL) Talent Report
        </label>
        <input
          type="text"
          id="callback_talent_report"
          name="callback_talent_report"
          value={formData.callback_talent_report}
          onChange={handleChange}
          className={`w-full p-2 border rounded-md ${errors.callback_talent_report ? 'border-red-500' : 'border-gray-300'}`}
          placeholder="https://example.com/callback"
        />
        <p className="mt-1 text-sm text-gray-500">
          URL that will be called when a talent report is generated after the talent finishes the evaluation.
        </p>
        {errors.callback_talent_report && (
          <p className="mt-1 text-sm text-red-600">{errors.callback_talent_report}</p>
        )}
      </div>

      {/* Callback URL New Job */}
      <div className="mb-6">
        <label 
          htmlFor="callback_new_job" 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          (Callback URL) New Job
        </label>
        <input
          type="text"
          id="callback_new_job"
          name="callback_new_job"
          value={formData.callback_new_job}
          onChange={handleChange}
          className={`w-full p-2 border rounded-md ${errors.callback_new_job ? 'border-red-500' : 'border-gray-300'}`}
          placeholder="https://example.com/callback"
        />
        <p className="mt-1 text-sm text-gray-500">
          URL that will be called when a job is created and processed successfully.
        </p>
        {errors.callback_new_job && (
          <p className="mt-1 text-sm text-red-600">{errors.callback_new_job}</p>
        )}
      </div>
    
      {/* Callback Email Address */}
      <div className="mb-6">
        <label 
          htmlFor="callback_email" 
          className="block text-sm font-medium text-gray-700 mb-1"
        >
          Callback Email Address 
        </label>
        <input
          type="email"
          id="callback_email"
          name="callback_email"
          value={formData.callback_email}
          onChange={handleChange}
          className={`w-full p-2 border rounded-md ${errors.callback_email ? 'border-red-500' : 'border-gray-300'}`}
          placeholder="notifications@example.com"
        />
        <p className="mt-1 text-sm text-gray-500">
          Email address that will receive notifications
        </p>
        {errors.callback_email && (
          <p className="mt-1 text-sm text-red-600">{errors.callback_email}</p>
        )}
      </div>
    </div>
  );
};

export default CallbackSettings;
